import { TypographyH3, TypographyP } from '@talentmesh/ui/components/typography';
import UIStrings from '@/Utils/UIStrings';

function BenchmarkHeader() {
    return (
        <div className="flex flex-col items-center justify-center gap-4">
            <TypographyH3 className="text-foreground text-center text-2xl leading-none">
                {UIStrings.ScoreBenchmarks}
            </TypographyH3>
            <TypographyP className="text-foreground text-center text-sm">
                {UIStrings.CompareTheOverallScore}
            </TypographyP>
        </div>
    );
}

export default BenchmarkHeader;
